export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://api-dev.platform.compatai.hidcloud.com/api/v1/platform";
export const API_BASE_URL_SSO =
  process.env.REACT_APP_API_BASE_URL_SSO ||
  "https://dev.platform.compatai.hidcloud.com/api/v1";
export const TENANT_ID =
  process.env.REACT_APP_TENANT_ID ||
  "platform-dev.FSfmwtUyJs0XKXGZhaFTz.chatbot.01HVYKEX8K2W0EHTF1CT2TK2EZ";
export const LOGIN_URL =
  process.env.REACT_APP_LOGIN_URL ||
  `https://dev.platform.compatai.hidcloud.com/api/v1/auth/login?tenant_id=${TENANT_ID}`;
export const LOGOUT_REDIRECT_URI =
  process.env.REACT_APP_LOGOUT_REDIRECT_URI ||
  `https://dev.hrchatbot.compatai.hidcloud.com/logout`;

/**
 * Extract tenant display name from tenant ID.
 * Format: env.orgId.tenantName.suffix (e.g. dev.xxx.playground.xxx -> "playground")
 */
export function getTenantDisplayName(tenantId: string): string {
  if (!tenantId || typeof tenantId !== "string") return "AIDEN";
  const parts = tenantId.trim().split(".");
  return parts.length >= 3 ? parts[2] : "AIDEN";
}


// For QA
/* export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://qa.platform.compatai.hidcloud.com/api/v1/platform";
export const API_BASE_URL_SSO =
  "https://qa.platform.compatai.hidcloud.com/api/v1";
export const TENANT_ID =
  "qa.FSfmwtUyJs0XKXGZhaFTz.hrchatbot.01HVYKEX8K2W0EHTF1CT2TK2EZ";
export const LOGIN_URL = `https://qa.platform.compatai.hidcloud.com/api/v1/auth/login?tenant_id=${TENANT_ID}`;
export const LOGOUT_REDIRECT_URI = `https://qa.hrchatbot.compatai.hidcloud.com/logout`; */
